import { Table, Button, Form, Input, Row, Col, DatePicker, Descriptions, message, notification, Card } from 'antd';
import type { DescriptionsProps } from 'antd';
import { useStore } from '@nanostores/react';
import { useEffect } from 'react';
import { Credit, User } from '../../api/go';
import { BanForm, clearState, EditForm, FieldType, loadList, store, updateCreditWithLog } from './state';
import { CreditHistory } from './credit_history';
import { BanHistory } from './ban_history';
import { DeviceHistory } from './device_history';

// 展示信用分的历史，当前值，和修改按钮

export default function UserCredit() {
  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  const state = useStore(store);

  const borderedItems: DescriptionsProps['items'] = [
    {
      key: 'nick',
      label: '昵称',
      children: <div>{state.info.NickName || ''}</div>,
    },
    {
      key: 'id',
      label: 'UserId',
      children: <div>{state.info.UserId || ''}</div>,
    },
    {
      key: 'status',
      label: '状态',
      children: <div>{state.info.Status === 0 ? '封禁' : '正常'}</div>,
    },
    {
      key: 'account_ban',
      label: '账户封禁提示',
      children: <div>{state.info.Status === 0 ? state.info.DisableRemark : '未封禁'}</div>,
    },
    {
      key: 'credit',
      label: '信誉分',
      children: <div>{state.current >= 0 ? state.current : '未查询到'}</div>,
    },
    {
      key: 'tips',
      label: '登录时提示',
      children: state.tips || '正常登录',
    },
  ];

  return (
    <div>
      <Row gutter={12}>
        <Col span={10}>
          <Card styles={{ header: { backgroundColor: '#efefef' } }} title="用户ID/昵称">
            <Form
              name="list"
              layout="horizontal"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={(values: FieldType) => {
                if (values.user_id && values.user_nick) {
                  notification.open({
                    key: 'user_credit-input-tips',
                    message: '多余的查询输入',
                    description: `输入两个查询条件，只会使用 User ID 进行查询`,
                  });
                }
                if (values.user_id || values.user_nick) {
                  const query: FieldType = {};
                  if (values.user_id) {
                    query.user_id = values.user_id;
                  } else if (values.user_nick) {
                    query.user_nick = values.user_nick;
                  }
                  loadList(query);
                }
              }}
              onValuesChange={(changed) => {
                const hasUserId = Object.hasOwn(changed, 'user_id');
                const hasUserNick = Object.hasOwn(changed, 'user_nick');

                if (hasUserId || hasUserNick) {
                  // 清除之前的查询结果，避免误操作
                  clearState();
                }
              }}
              autoComplete="off"
            >
              <Form.Item<FieldType> label="User ID" name="user_id">
                <Input disabled={state.loading} allowClear />
              </Form.Item>

              <Form.Item<FieldType> label="昵称" name="user_nick">
                <Input disabled={state.loading} allowClear />
              </Form.Item>

              <Form.Item label={null}>
                <Button type="primary" htmlType="submit" loading={state.loading}>
                  查询
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col span={10}>
          <Card styles={{ header: { backgroundColor: '#efefef' } }} title="信用分修改">
            <Form
              name="edit"
              layout="horizontal"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={(values: EditForm) => {
                let dataValid = false;
                if (values.remark && values.remark.length >= 5) {
                  dataValid = true;
                }
                if (!dataValid) {
                  alert('备注长度至少5个字');
                  return;
                }
                updateCreditWithLog(values);
              }}
              autoComplete="off"
            >
              <Form.Item<EditForm> label="改成多少分" name="score" required>
                <Input disabled={state.loading} />
              </Form.Item>

              <Form.Item<EditForm> label="用户可见原因" name="reason" required>
                <Input disabled={state.loading} />
              </Form.Item>
              <Form.Item<EditForm> label="备注（用户不可见）" name="remark" required>
                <Input disabled={state.loading} />
              </Form.Item>

              <Form.Item label={null}>
                <Button type="primary" htmlType="submit" disabled={!state.info.UserId}>
                  修改
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
      <Row gutter={12} style={{ marginTop: 12 }}>
        <Col span={10}>
          <Card styles={{ header: { backgroundColor: '#efefef' } }} title="临时封禁">
            <Form
              name="ban"
              layout="horizontal"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={(values: BanForm) => {
                let dataValid = false;
                if (values.remark && values.remark.length >= 5) {
                  dataValid = true;
                }
                if (!dataValid) {
                  alert('备注长度至少5个字');
                  return;
                }

                console.log('ban form', values);
                Credit.banTime({
                  ...values,
                  userId: state.info.UserId,
                  banEnd: values.banEnd.format('YYYY-MM-DD'),
                }).then(() => {
                  message.success('操作成功');
                  loadList({ user_id: state.info.UserId });
                });
              }}
              autoComplete="off"
            >
              <Form.Item<BanForm> label="封禁结束时间" name="banEnd" required>
                <DatePicker style={{ width: '100%' }} disabled={state.loading} />
              </Form.Item>
              <Form.Item<BanForm> label="用户可见原因" name="reason" required>
                <Input disabled={state.loading} />
              </Form.Item>
              <Form.Item<BanForm> label="备注（用户不可见）" name="remark" required>
                <Input disabled={state.loading} />
              </Form.Item>

              <Form.Item label={null}>
                <Button type="primary" color="danger" htmlType="submit" disabled={!state.info.UserId}>
                  封禁用户登录
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col span={10}>
          <Card styles={{ header: { backgroundColor: '#efefef', color: 'red' } }} title="解除临时封禁">
            <Form
              name="unban"
              layout="horizontal"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={(values: EditForm) => {
                let dataValid = false;
                if (values.remark && values.remark.length >= 5) {
                  dataValid = true;
                }
                if (!dataValid) {
                  alert('备注长度至少5个字');
                  return;
                }
                Credit.unbanTime({
                  ...values,
                  userId: state.info.UserId,
                }).then(() => {
                  message.success('操作成功');
                  loadList({ user_id: state.info.UserId });
                });
              }}
              autoComplete="off"
            >
              <Form.Item<EditForm> label="用户可见原因" name="reason" required>
                <Input disabled={state.loading} />
              </Form.Item>
              <Form.Item<EditForm> label="备注（用户不可见）" name="remark" required>
                <Input disabled={state.loading} />
              </Form.Item>

              <Form.Item label={null}>
                <Button type="primary" htmlType="submit" disabled={!state.info.UserId}>
                  解除登录封禁
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>

      {/* 账号封禁处理 */}
      <Row gutter={12} style={{ marginTop: 12 }}>
        <Col span={10}>
          <Card styles={{ header: { backgroundColor: '#efefef' } }} title="永久封禁/自动扣减信用分到0">
            <Form
              name="ban_account"
              layout="horizontal"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={(values: BanForm) => {
                let dataValid = false;
                if (values.remark && values.remark.length >= 5) {
                  dataValid = true;
                }
                if (!dataValid) {
                  alert('备注长度至少5个字');
                  return;
                }

                const userId = state.info.UserId;
                const remark = values.remark;
                User.banList([userId], remark, 0, {}).then(async () => {
                  await Credit.update({
                    user_id: userId,
                    score: 0,
                    reason: remark,
                    remark: remark,
                  });

                  message.success('操作成功');
                  loadList({ user_id: userId });
                });
              }}
              autoComplete="off"
            >
              <Form.Item<BanForm> label="用户可见原因" name="remark" required>
                <Input disabled={state.loading} />
              </Form.Item>

              <Form.Item label={null}>
                <Button type="primary" color="danger" htmlType="submit" disabled={!state.info.UserId}>
                  封禁用户账号
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col span={10}>
          <Card styles={{ header: { backgroundColor: '#efefef', color: 'red' } }} title="解除永久封禁/自动恢复信用分到100">
            <Form
              name="unban_account"
              layout="horizontal"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={(values: BanForm) => {
                let dataValid = false;
                if (values.remark && values.remark.length >= 5) {
                  dataValid = true;
                }
                if (!dataValid) {
                  alert('备注长度至少5个字');
                  return;
                }

                const userId = state.info.UserId;
                const remark = values.remark;
                User.unbanList([userId], remark).then(async () => {
                  await Credit.update({
                    user_id: userId,
                    score: 100,
                    reason: remark,
                    remark: remark,
                  });

                  message.success('操作成功');
                  loadList({ user_id: userId });
                });
              }}
              autoComplete="off"
            >
              <Form.Item<BanForm> label="用户可见原因" name="remark" required>
                <Input disabled={state.loading} />
              </Form.Item>
              <Form.Item label={null}>
                <Button type="primary" color="danger" htmlType="submit" disabled={!state.info.UserId}>
                  解封用户账号
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
      <div style={{ margin: '24px 0' }}>
        <Descriptions bordered items={borderedItems}></Descriptions>
      </div>
      <CreditHistory />
      <BanHistory />
      <DeviceHistory />
    </div>
  );
}
